import type { JSX } from 'solid-js';
import { Suspense } from 'solid-js';

import { emitEvtBus, Events } from '~/hook/useEvtBus';

type Props = ParentProps<{
  minDelay?: {
    trigger: Accessor<any>;
    delay?: number;
  };
  fallback?: JSX.Element;
}>;

const Fallback = (props: ParentProps) => {
  createRenderEffect(() => {
    // console.log('===walker===Fallback PENDING_REGISTER', Math.random());
    emitEvtBus(Events.PENDING_REGISTER);
  });

  onCleanup(() => {
    // console.log('===walker===Fallback PENDING_RESOLVE', Math.random());
    emitEvtBus(Events.PENDING_RESOLVE);
  });

  return props.children;
};

const BZSuspense = (props: Props) => {
  const [source, setSource] = createSignal<number>();

  const [pending] = createResource(source, () => {
    return new Promise<boolean>((resolve) => {
      setTimeout(() => resolve(false), props.minDelay?.delay ?? 500);
    });
  });

  createEffect(
    on(
      () => props.minDelay?.trigger(),
      (isTrigger) => {
        isTrigger && setSource(new Date().getTime());
      },
      { defer: true }
    )
  );

  return (
    <Suspense fallback={<Fallback>{props.fallback}</Fallback>}>
      {pending()}
      {props.children}
    </Suspense>
  );
};

export default BZSuspense;
